import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'

export default class Mapbox {
    constructor({
        container = 'map',
        $container = document.getElementById(container),
        style,
        cities = [],
        markerImageUrl,
        accessToken,
    }) {

        if ($container.dataset?.cities) {

            cities = JSON.parse($container.dataset.cities)
        }

        if (!container || !style || !cities.length || !markerImageUrl || !accessToken) {
            throw new Error('Mapbox: missing required options')
        }

        mapboxgl.accessToken = accessToken

        this.container = container
        this.style = style
        this.cities = [...cities]
        this.markerImageUrl = markerImageUrl

        this.currentCityIndex = 0
        this.zoomDefaultLevel = window.innerWidth < 768 ? 6 : 7

        this.init()
    }

    shuffleCities() {
        for (let i = this.cities.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1))
                ;[this.cities[i], this.cities[j]] = [this.cities[j], this.cities[i]]
        }
    }

    init() {
        this.shuffleCities()

        this.map = new mapboxgl.Map({
            container: this.container,
            style: this.style,
            center: [8.5455, 46.5154],
            zoom: this.zoomDefaultLevel,
            pitch: 20,
            bearing: -15,
        })

        this.map.addControl(new mapboxgl.NavigationControl(), 'top-right')

        this.map.on('load', () => {
            this.addMarkers()
            this.bindUI()
        })
    }

    addMarkers() {
        this.cities.forEach((city) => {
            const el = document.createElement('div')
            el.style.backgroundImage = `url(${this.markerImageUrl})`
            el.style.backgroundSize = 'contain'
            el.style.width = '32px'
            el.style.height = '44px'
            el.style.cursor = 'pointer'

            new mapboxgl.Marker(el, { anchor: 'bottom' })
                .setLngLat(city.coords)
                .addTo(this.map)

            el.addEventListener('click', () => {
                this.flyToCity(city)
                this.toggleOverlay(true)
                this.updateOverlay(city)
            })
        })
    }

    flyToCity(city) {
        this.map.flyTo({
            center: city.coords,
            zoom: city.zoom,
            essential: true,
            pitch: 60,
            bearing: -25,
            speed: 1.2,
            curve: 0.65,
            easing: (t) => t * (2 - t),
            duration: 6800,
        })
    }

    bindUI() {
        document.querySelector('.mapbox__card-next')?.addEventListener('click', () => {
            const city = this.cities[this.currentCityIndex]
            this.flyToCity(city)
            this.updateOverlay(city)
            this.currentCityIndex = (this.currentCityIndex + 1) % this.cities.length
        })

        document.querySelector('.mapbox__start-fly')?.addEventListener('click', () => {
            this.currentCityIndex = Math.max(this.currentCityIndex, 1)
            const city = this.cities[this.currentCityIndex]
            this.flyToCity(city)
            this.toggleOverlay(true)
            this.updateOverlay(city)
            this.currentCityIndex = (this.currentCityIndex + 1) % this.cities.length
        })
    }

    toggleOverlay(show) {
        document.querySelector('.mapbox__overlaybox-startinfo')?.style.setProperty(
            'display',
            show ? 'none' : 'block'
        )
        document.querySelector('.mapbox__overlaybox-card')?.style.setProperty(
            'display',
            show ? 'block' : 'none'
        )
    }

    updateOverlay(city) {
        const image = document.getElementById('overlay-image')
        const title = document.getElementById('place-title')
        const subtitle = document.getElementById('place-subtitle')
        const text = document.getElementById('place-text')
        const button = document.getElementById('place-button')

        if (!image) return

        image.classList.remove('loaded')
        image.src = city.img

        title.textContent = city.name
        subtitle.textContent = city.subtitle
        text.textContent = city.text
        button.href = city.url

        image.onload = () => image.classList.add('loaded')
    }
}
